module.exports = __webpack_public_path__ + "img/new6.90baa95e.png";